import { Button, Menu, MenuItem } from '@material-ui/core';
import React from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

type Props = {
  logout: () => void;
  name: string;
};

export default function AuthMenu({ logout, name }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoutHandler = () => {
    logout();
    handleClose();
  };

  return (
    <div>
      <Button
        color="inherit"
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
      >
        {name}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>ACCOUNT</MenuItem>
        <MenuItem onClick={handleClose}>PURCHASE ORDERS</MenuItem>
        <MenuItem onClick={handleClose}>PAYMENT METHODS</MenuItem>
        <MenuItem onClick={logoutHandler}>SIGN OUT</MenuItem>
      </Menu>
    </div>
  );
}
